import { render, staticRenderFns } from "./WorkflowConfigTable.vue?vue&type=template&id=0190d81a"
import script from "./WorkflowConfigTable.vue?vue&type=script&lang=js"
export * from "./WorkflowConfigTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports